import {
  Box,
  Button,
  InputBase,
  TableCell,
  TableRow,
  Typography,
  CircularProgress,
} from "@mui/material";
import React, { useEffect, useState, useRef } from "react";
import styled from "styled-components";
import CustomTable from "../../components/common-components/CustomTable";
import { ArrowRightCircleIcon } from "../../assets/Icon/ArrowIcon";
import SearchIcon from "@mui/icons-material/Search";

import { useAppDispatch } from "../../stores/store";
import { useSelector } from "react-redux";

import CommonPagination from "../../components/common-components/CommonPagination";

import { useNavigate } from "react-router-dom";
import { getOrderList } from "../../stores/itin";
import ListLoadingNew from "../../components/common-components/ListLoadingNew";
import NoOrdersFound from "../../components/common-components/NoOrdersFound";
import SearchDropdown from "../../components/common-components/SearchDropdown";
import { ButtonWrapper } from "../../components/style/modalStyle";
import { getCompanyList } from "../../stores/incorporation";
import { DatePicker, LocalizationProvider } from "@mui/x-date-pickers";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import { formatDate, sortData } from "../../utils/functions";
import dayjs, { Dayjs } from "dayjs";
type SortOrder = "asc" | "desc";
const Itin = () => {
  const dispatch = useAppDispatch();
  const {
    data: agentList,
    status,
    error,
    total_records,
  } = useSelector((state: any) => state.itin);
  const { companyList, companyListStatus } = useSelector(
    (state: any) => state.incorporation
  );

  const [page, setPage] = useState(1);
  const [openModal, setOpenModal] = useState(false);
  const [openDeleteModal, setOpenDeleteModal] = useState(false);
  const [selectedId, setSelectedId] = useState<number | null>(null);
  const [startDate, setStartDate] = useState<Dayjs | null>(null);
  const { userId } = useSelector((store: any) => store.auth);
  const [order, setOrder] = useState<SortOrder>("asc");
  const [orderBy, setOrderBy] = useState("");
  const [searchQuery, setSearchQuery] = useState<any>("");
  const [currentPage, setCurrentPage] = useState(1);
  const [isFilterApplied, setIsFilterApplied] = useState<boolean>(false);
  const [selectedCompany, setSelectedCompany] = useState<any>(null);
  const [limit] = useState(10);
  const [debouncedSearch, setDebouncedSearch] = useState<string>("");
  const navigate = useNavigate();
  const dropdownRef = useRef<any>(null);
  useEffect(() => {
    const handler = setTimeout(() => {
      setDebouncedSearch(searchQuery);
    }, 600);

    return () => {
      clearTimeout(handler);
    };
  }, [searchQuery]);

  useEffect(() => {
    fetchAgents();
  }, [page, limit]);

  const fetchAgents = () => {
    const offset = (page - 1) * limit;

    dispatch<any>(
      getOrderList({
        userId: userId,
        offset,
        limit,
        search: selectedCompany,
        start_date: startDate ? startDate.format("YYYY-MM-DD") : "",
      })
    );
  };

  const itinStatus: Record<
    number,
    { label: string; bgColor: string; textColor: string }
  > = {
    0: { label: "Pending", bgColor: "#FFF5DB", textColor: "#E7AB12" },
    1: {
      label: "Ready For Signature",
      bgColor: "#FFF5DB",
      textColor: "#E7AB12",
    },
    2: { label: "Under Review", bgColor: "#FFF5DB", textColor: "#E7AB12" },
    3: { label: "Submitted", bgColor: "#EAF1FA", textColor: "#2977CC" },
    4: { label: "Completed", bgColor: "#D9FFD2", textColor: "#3DC826" },
    99: { label: "Deactivated", bgColor: "#ff000020", textColor: "#ff0000" },
  };
  const timestamp = agentList?.[0]?.created_at;
  const date = timestamp ? timestamp.split("T")[0] : "-";
  const handleSearchChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    setSearchQuery(event.target.value);

    setPage(1);
  };

  const handlePageChange = (newPage: number) => {
    setPage(newPage);
    setCurrentPage(newPage);
  };
  const handleOpen = () => setOpenModal(true);

  const handleClose = () => {
    setOpenModal(false);
    setSelectedId(null);
  };
  const fetchCompanyList = () => {
    dispatch<any>(
      getCompanyList({
        search: debouncedSearch,
        product_id: 1,
      })
    );
  };
  useEffect(() => {
    fetchCompanyList();
  }, [debouncedSearch]);

  const handleCloseDeleteModal = () => {
    setOpenDeleteModal(false);
    setSelectedId(null);
  };

  const handleOpenDeleteModal = (agentId: number) => {
    setSelectedId(agentId);
    setOpenDeleteModal(true);
  };
  const filteredAgents = Array.isArray(agentList)
    ? agentList.filter((item: any) =>
        item?.sku?.toLowerCase().includes(searchQuery.toLowerCase())
      )
    : [];
  const handleSubmit = () => {
    dispatch<any>(
      getOrderList({
        userId: userId,
        offset: 0,
        limit: 10,
        search: selectedCompany,
        start_date: startDate ? startDate.format("YYYY-MM-DD") : "",
      })
    );
    setIsFilterApplied(true);
    if (dropdownRef.current) {
      dropdownRef.current.close();
    }
  };

  const handleDropdownClose = () => {
    // This will be called when the dropdown closes
  };

  const handleCancelClick = () => {
    if (dropdownRef.current) {
      dropdownRef.current.close();
    }
    dispatch<any>(
      getOrderList({
        userId: userId,
        offset: 0,
        limit: 10,
        search: "",
        start_date: "",
      })
    );
    setSelectedCompany("");
    setSearchQuery("");
    setStartDate(null);
  };
  const handleApplyNow = () => {
    window.open("https://theitin.com/", "_blank");
  };
  const handleSortOrder = (column: string) => {
    if (orderBy === column) {
      setOrder((prev) => (prev === "asc" ? "desc" : "asc"));
    } else {
      setOrderBy(column);
      setOrder("asc");
    }
  };

  const sortedList = sortData(agentList, orderBy, order);
  return (
    <>
      <StyledBox sx={{ paddingY: "16px" }}>
        <Box
          sx={{
            display: "flex",
            flexDirection: "column",
            gap: "20px",
            padding: "20px",
            "@media (min-width: 600px)": {
              flexDirection: "row",
              justifyContent: "space-between",
              alignItems: "center",
            },
          }}
        >
          <Title>ITIN Applications</Title>

          <Box
            sx={{
              display: "flex",
              flexDirection: "column",
              gap: "10px",
              "@media (min-width: 600px)": {
                flexDirection: "row",
                alignItems: "center",
              },
            }}
          >
            <SearchDropdown
              ref={dropdownRef}
              onClose={handleDropdownClose}
              selectedCompany={selectedCompany}
              isFilterApplied={isFilterApplied}
              startDate={startDate}
            >
              <Box
                sx={{
                  display: "flex",
                  flexDirection: "column",
                  gap: "10px",
                  padding: "30px 20px",
                }}
              >
                <Typography
                  variant="h4"
                  sx={{ fontSize: "16px", fontWeight: "500", mb: "6px" }}
                >
                  Order Created
                </Typography>
                <LocalizationProvider dateAdapter={AdapterDayjs}>
                  {/* <DemoContainer components={['DatePicker']}> */}
                  <DatePicker
                    label=""
                    value={startDate}
                    onChange={(val) => {
                      if (val) {
                        setStartDate(dayjs.utc(val.format("YYYY-MM-DD")));
                      }
                      setIsFilterApplied(true);
                    }}
                    slotProps={{
                      textField: {
                        fullWidth: true,
                        size: "medium",
                        sx: {
                          flex: 1,
                          maxWidth: "340px",
                          boxShadow: "0px 2px 4px 0px #D1DEEB33",
                          "& .MuiOutlinedInput-root": {
                            height: "45px",
                            "& fieldset": {
                              border: "0.5px solid #EAF1FA",
                              borderRadius: "8px",
                            },
                            "&:hover fieldset": {
                              border: "0.5px solid #EAF1FA",
                              borderRadius: "8px",
                            },
                            "&.Mui-focused fieldset": {
                              border: "0.5px solid #2977CC",
                            },
                          },
                        },
                        // onClick: () => setInvoiceDateOpen(true),
                      },
                    }}
                  />
                  {/* </DemoContainer> */}
                </LocalizationProvider>
                <Typography
                  variant="h4"
                  sx={{
                    fontSize: "16px",
                    fontWeight: "500",
                    mb: "6px",
                    marginTop: "10px",
                  }}
                >
                  Company Name
                </Typography>
                <SearchWrapper>
                  <SearchIcon />
                  <StyledInputBase
                    placeholder="Search company name..."
                    inputProps={{ "aria-label": "search" }}
                    value={searchQuery}
                    onChange={handleSearchChange}
                  />
                </SearchWrapper>
                <Box
                  sx={{
                    maxHeight: "160px",
                    minHeight: "50px",
                    overflowY: "auto",
                    overflowX: "hidden",
                    display: "flex",
                    flexDirection: "column",
                    "&::-webkit-scrollbar": {
                      width: "6px",
                    },
                    "&::-webkit-scrollbar-track": {
                      background: "#f1f1f1",
                      borderRadius: "3px",
                    },
                    "&::-webkit-scrollbar-thumb": {
                      background: "#c1c1c1",
                      borderRadius: "3px",
                    },
                    "&::-webkit-scrollbar-thumb:hover": {
                      background: "#a8a8a8",
                    },
                  }}
                >
                  {companyListStatus === "loading" ? (
                    <Box
                      sx={{
                        display: "flex",
                        justifyContent: "center",
                        alignItems: "center",
                        minHeight: "50px",
                      }}
                    >
                      <ListLoadingNew />
                    </Box>
                  ) : companyList?.length > 0 ? (
                    companyList?.map((item: any, index: number) => (
                      <Box
                        key={index}
                        onClick={() => setSelectedCompany(item)}
                        sx={{
                          cursor: "pointer",
                          p: 1,
                          borderRadius: "8px",
                          backgroundColor:
                            selectedCompany === item
                              ? "#e3f2fd"
                              : "transparent",
                          "&:hover": {
                            backgroundColor:
                              selectedCompany === item ? "#e3f2fd" : "#f5f5f5",
                          },
                        }}
                      >
                        <Typography
                          sx={{
                            fontSize: "14px",
                            color: "#333333",
                            whiteSpace: "nowrap",
                            overflow: "hidden",
                            textOverflow: "ellipsis",
                          }}
                        >
                          {item}
                        </Typography>
                      </Box>
                    ))
                  ) : (
                    <Box
                      sx={{
                        height: "160px",
                        minHeight: "50px",
                        overflowY: "auto",
                        overflowX: "hidden",
                      }}
                    >
                      <Typography sx={{ p: 1, color: "gray" }}>
                        No results found
                      </Typography>
                    </Box>
                  )}
                </Box>

                <ButtonWrapper
                  onClick={handleClose}
                  isTax
                  isSearch
                  sx={{ marginTop: "10px" }}
                >
                  <Button
                    variant="contained"
                    onClick={handleSubmit}
                    size="medium"
                    sx={{ width: "120px" }}
                    disabled={!selectedCompany && !startDate}
                  >
                    {false ? (
                      <CircularProgress
                        size={24}
                        sx={{
                          "& svg": {
                            stroke: "url(#gradientColor)",
                          },
                        }}
                      />
                    ) : (
                      "Apply"
                    )}
                  </Button>
                  <Button
                    variant="text"
                    onClick={handleCancelClick}
                    size="medium"
                  >
                    Cancel
                  </Button>
                </ButtonWrapper>
              </Box>
            </SearchDropdown>
            {/* <SearchWrapper>
                <SearchIcon />
                <StyledInputBase
                  placeholder="Search here..."
                  inputProps={{ "aria-label": "search" }}
                  value={searchQuery}
                  onChange={handleSearchChange}
                />
              </SearchWrapper> */}
          </Box>
        </Box>

        <CustomTable
          headings={[
            "ORDER ID",
            "ITIN Applicant",
            "ORDER CREATED",
            "STATUS",
            "ACTION",
          ]}
          isSort
          sortOrder={handleSortOrder}
          data={sortedList}
          orderBy={orderBy}
          order={order}
        >
          {status === "loading" ? (
            <TableRow>
              <TableCell
                colSpan={5}
                sx={{
                  textAlign: "center",
                  padding: "40px",
                  // height: "200px",
                  // verticalAlign: "middle"
                }}
              >
                <ListLoadingNew isheight />
              </TableCell>
            </TableRow>
          ) : sortedList?.length > 0 && status !== "loading" ? (
            <>
              {sortedList?.map((item: any, index: number) => {
                const timestamp = item?.created_at;
                const date = timestamp ? timestamp.split("T")[0] : "-";
                return (
                  <TableRow>
                    <TableCell
                      sx={{
                        width: "25%",
                      }}
                    >
                      <Typography>{item?.order_id || "-"}</Typography>
                    </TableCell>
                    <TableCell
                    // sx={{
                    //   width: "45%",
                    // }}
                    >
                      <Typography>{item?.sku || "-"}</Typography>
                    </TableCell>
                    <TableCell
                    // sx={{
                    //   width: "40%",
                    // }}
                    >
                      <Typography>{formatDate(date)}</Typography>
                    </TableCell>

                    <TableCell
                      sx={{
                        width: "25%",
                      }}
                    >
                      <Box
                        sx={{
                          minWidth: "113px",
                          width: "auto",

                          textAlign: "center",
                          display: "inline-block",
                          padding: "9px",
                          // paddingx: "9px",
                          borderRadius: "6px",
                          fonsize: "12px",
                          fontWeight: "600",
                          backgroundColor:
                            itinStatus[item?.status]?.bgColor || "#ccc",
                          color: itinStatus[item?.status]?.textColor || "#000",

                          whiteSpace: "nowrap",

                          cursor: "pointer",
                        }}
                      >
                        {itinStatus[item?.status]?.label}
                      </Box>
                    </TableCell>
                    <TableCell
                      sx={{
                        width: "15%",
                      }}
                    >
                      <Box
                        sx={{
                          display: "flex",
                          alignItems: "center",
                          justifyContent: "start",

                          gap: 1,
                        }}
                      >
                        {item?.id && item?.status !== 99 && (
                          <Box
                            onClick={() => navigate(`/itin/${item?.id}`)}
                            style={{ cursor: "pointer" }}
                          >
                            <ArrowRightCircleIcon />
                          </Box>
                        )}
                      </Box>
                    </TableCell>
                  </TableRow>
                );
              })}
            </>
          ) : (
            <TableRow>
              <TableCell colSpan={5}>
                <NoOrdersFound
                  title="No ITIN Application Found"
                  breakWords={["submitted"]}
                  handleApplyNow={handleApplyNow}
                  showButton={isFilterApplied ? false : true}
                  subTitle={
                    isFilterApplied
                      ? ""
                      : "It looks like no ITIN applications have been submitted yet. Please apply now."
                  }
                />
              </TableCell>
            </TableRow>
          )}
        </CustomTable>
        {/* Pagination */}
        {Math.ceil(total_records / limit) > 1 && (
          <Box sx={{ display: "flex", justifyContent: "end", mt: 3 }}>
            <CommonPagination
              currentPage={page}
              totalPages={Math.ceil(total_records / limit)}
              onPageChange={handlePageChange}
            />
          </Box>
        )}
      </StyledBox>
    </>
  );
};

export default Itin;

const StyledBox = styled(Box)({
  background: "#ffffff",
  boxShadow: "0px 2px 40px 0px #DDE3EA33",
  borderRadius: "10px",
  // padding: "16px",
  margin: "16px",
});

const Container = styled(Box)({
  display: "flex",
  alignItems: "center",
  justifyContent: "space-between",
  padding: "20px",
});

const Title = styled(Typography)({
  color: "#01060B !important",
  fontSize: "20px !important",
  fontWeight: "600 !important",
});

const SearchContainer = styled(Box)({
  display: "flex",
  gap: "10px",
  alignItems: "center",
});

const SearchWrapper = styled(Box)({
  display: "flex",
  alignItems: "center",
  background: "#F6F9FD",
  color: "#6B6B6B",
  borderRadius: "8px",
  padding: "5px 10px",
  "&:hover": {
    background: "#F6F9FD",
  },
});

const StyledButton = styled(Button)({
  width: "120px !important",
  whiteSpace: "nowrap",
  borderRadius: "6px !important",
  height: "40px !important",
});

const StyledInputBase = styled(InputBase)({
  minWidth: "300px",
  padding: "3px",
});
